/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */
import {Sandbox} from '@exc/core';

// Campaign Launch Page
export const campaign = {
  appId: 'acs',
  path: '/campaign',
  distributionList: ['Build-neolane@adobe.com'],
  serviceCode: 'dma_campaign',
  type: 'application',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.SERVER,
    sources: {
      dev: 'https://localhost.corp.adobe.com:1337',
      qa: 'https://experience-qa.adobe.com/solutions/pixel-campaign-launch-page',
      stage: 'https://experience-stage.adobe.com/solutions/pixel-campaign-launch-page',
      prod: 'https://experience.adobe.com/solutions/pixel-campaign-launch-page'
    }
  },
  access: ['dma_campaign']
};

// Campaign Instances
export const campaignSub = {
  appId: 'acs',
  path: '/campaign/:mySubOrg',
  distributionList: ['Build-neolane@adobe.com'],
  serviceCode: 'dma_campaign',
  sandbox: {
    history: {
      type: Sandbox.HISTORY_TYPES.SERVER,
      config: {spinnerOnChange: true, absolutePaths: true}
    },
    sources: {
      dev: {
        discovery: 'https://localhost.corp.adobe.com/rest/head/imsSession/',
        withCredentials: true,
        url: 'https://localhost.corp.adobe.com/{1}?__securitytoken={securityToken}',
        defaults: {1: 'view/home'}
      },
      qa: {
        discovery: 'https://{mySubOrg}.qa.campaign.adobe.com/rest/head/imsSession/',
        withCredentials: true,
        url: 'https://{mySubOrg}.qa.campaign.adobe.com/{1}?__securitytoken={securityToken}',
        defaults: {1: 'view/home'}
      },
      stage: {
        discovery: 'https://{mySubOrg}.qa.campaign.adobe.com/rest/head/imsSession/',
        withCredentials: true,
        url: 'https://{mySubOrg}.qa.campaign.adobe.com/{1}?__securitytoken={securityToken}',
        defaults: {1: 'view/home'}
      },
      // All production IMS environment
      prod: {
        discovery: 'https://{mySubOrg}.campaign.adobe.com/rest/head/imsSession/',
        withCredentials: true,
        url: 'https://{mySubOrg}.campaign.adobe.com/{1}?__securitytoken={securityToken}',
        defaults: {1: 'view/home'}
      },
      qe: '', // TO FILL when production (apparently AZURE URLs)
      rd: {
        discovery: 'https://{mySubOrg}.rd.campaign.adobe.com/rest/head/imsSession/',
        withCredentials: true,
        url: 'https://{mySubOrg}.rd.campaign.adobe.com/{1}?__securitytoken={securityToken}',
        defaults: {1: 'view/home'}
      }
    },
    pageTimeout: 90000
  },
  access: ['dma_campaign']
};
